import { AsyncActionHandler } from 'action-handler';
import { triggerAppSync } from 'actions/gallery';
import { triggerContinueInstall } from 'actions/install-flow';
import {
  markTileInstalled,
  markTileRemoved,
  setPendingAppInstallStatus,
  setPendingTileInstalls
} from 'actions/registry';
import App from 'models/app';

export default new AsyncActionHandler({
  name: 'install_tile',
  stateProp: 'installTile',
  handler: (appId, parentInstalled) => async (dispatch, getState) => {
    const state = getState();
    const app = App.selectFromState(appId, state);

    await dispatch(setPendingAppInstallStatus(app));
    if (parentInstalled) {
      await dispatch(setPendingTileInstalls(app.id, true));
    } else {
      await dispatch(
        triggerContinueInstall({
          show: false,
          hasBeenSeen: true,
          shouldContinue: true
        })
      );
    }

    // Mark app installed in AIS
    await dispatch(markTileInstalled(appId));

    // Tell mobile to start app sync
    if (!parentInstalled) {
      await dispatch(triggerAppSync({ force: true }));
    } else {
      let commsResponse;
      try {
        commsResponse = await window.__webview_comms__.trigger('tiles-refresh');
      } catch (_) {
        await dispatch(markTileRemoved(appId));
        await dispatch(setPendingTileInstalls(app.id, false));
      }

      const triggerSuccesfull = commsResponse
        ? commsResponse['tiles-refreshed-successfully']
        : false;

      if (triggerSuccesfull !== true) {
        await dispatch(markTileRemoved(appId));
        await dispatch(setPendingTileInstalls(app.id, false));
      }
    }
  }
});
